<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="listings">
					<app-heading title="Listings" />
					<app-row>
						<app-cell>
							<app-data-table
								:items="listings"
								:headers="headers"
								:total="count"
								@update="fetchListings"
							>
								<template v-slot:host="{ item }">
									<span v-if="item.host">
										<a :href="`https://www.airbnb.com/users/show/${item.host.host_id}`" target="_blank">
											<span v-if="item.host.last_name && item.host.first_name">
												{{ item.host.last_name }}, {{ item.host.first_name }}
											</span>
											<span v-else-if="item.host.last_name">
												{{ item.host.last_name }}
											</span>
											<span v-else-if="item.host.first_name">
												{{ item.host.first_name }}
											</span>
											<i v-else>No Name</i>
										</a>
									</span>
									<i v-else>Host Not Found</i>
								</template>
								<template v-slot:actions="{ item }">
									<app-button
										color="secondary"
										table
										:to="{ name: 'market-airbnb-listing', params: { listing: item._id } }"
									>
										Availabilities
									</app-button>
									<app-button
										color="secondary"
										table
										:href="`https://www.airbnb.com/rooms/${item.listing_id}`"
										target="_blank"
										icon="fa-external-link-alt"
									>
										Airbnb
									</app-button>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { marketMathAirbnbTabs } from '@/datasources/tabs'

export default {
	data() {
		return {
			listings: [],
			count: -1,
			tabs: [],
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Address',
				value: 'address',
				sortable: true,
			}, {
				text: 'Zip/Postal code',
				value: 'zipcode',
				sortable: true,
			}, {
				text: 'Host',
				value: 'host',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	async mounted() {
		this.tabs = marketMathAirbnbTabs(this.marketId)
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
	},
	methods: {
		async fetchListings(pagination) {
			const request = this.$ravello.graphql('airbnblistings')
				.parent(this.$ravello.graphql('market', this.marketId))
				.fromPagination(pagination)
				.fields(['_id', 'name', 'address', 'zipcode', 'listing_id'])
				.include(this.$ravello.graphql('host').fields(['host_id', 'first_name', 'last_name']))

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.listings = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
